import { baseSeriesMark } from "../base/constant";

export const scatterSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    point: {
        name: "point",
        type: "symbol"
    }
});
//# sourceMappingURL=constant.js.map
